"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var StyledLogo = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "eaj4o6z0"
})(_base.default, ";", _font.default, ";display:inline-flex;height:32px;font-size:26px;flex-direction:row;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;color:", function (props) {
  return (0, _utils.getTextColor)(props);
}, ";&:hover,&:focus{text-decoration:none;}& > *{height:100%;display:inline-flex;align-items:center;}");
var icon = /*#__PURE__*/
(0, _reactEmotion.css)("margin-right:8px;");
var lightText = /*#__PURE__*/
(0, _reactEmotion.css)("font-weight:300;margin-right:4px;");
var darkText = /*#__PURE__*/
(0, _reactEmotion.css)("font-weight:600;");
var Logo = /*#__PURE__*/
function (_Component) {
  function Logo() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Logo.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      logoProps = _objectWithoutProperties(_this$props, ["children"]);
    return _react.default.createElement(StyledLogo, logoProps, this.props.children);
  };
  _inheritsLoose(Logo, _Component);
  return Logo;
}(_react.Component);
_defineProperty(Logo, "Icon", function (_ref) {
  var children = _ref.children;
  return _react.default.createElement("span", {
    className: icon
  }, children);
});
_defineProperty(Logo, "Light", function (_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("span", {
    className: lightText
  }, children);
});
_defineProperty(Logo, "Dark", function (_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("span", {
    className: darkText
  }, children);
});
Logo.propTypes = {
  children: _propTypes.default.any // eslint-disable-line
};

var _default = Logo;
exports.default = _default;